export const LINECHART_AXIS_STEP_SIZE = 3;